// `t(key, params)`: the single way UI code gets a string (ui-flow §1, §13). DOM-free.

import { EN } from './en.js';

export type I18nKey = keyof typeof EN;
export type I18nParams = Readonly<Record<string, string | number>>;

const PLACEHOLDER = /\{([^{}]+)\}/g;

/** Fills `{name}` placeholders from `params`; unknown placeholders are left as written. */
export function format(template: string, params?: I18nParams): string {
  if (!params) return template;
  return template.replace(PLACEHOLDER, (whole, name: string) => {
    const v = Object.prototype.hasOwnProperty.call(params, name) ? params[name] : undefined;
    return v === undefined ? whole : String(v);
  });
}

/** The English string for `key`, with `params` filled in. */
export function t(key: I18nKey, params?: I18nParams): string {
  return format(EN[key], params);
}

/** True if `key` names a string in the table (for keys built at runtime, e.g. `dialog.<id>.body`). */
export function hasKey(key: string): key is I18nKey {
  return Object.prototype.hasOwnProperty.call(EN, key);
}
